import React, {FC} from 'react'
//@ts-ignore
import withLookups from 'shared/containers/withLookups'
import { constants as DCConstants } from '../../../DetailsContainer'

import ReserveAuto from './ReserveAuto'
import ReserveMan from './ReserveMan'
import ReserveCalc from './ReserveCalc'
import Controls from './Controls'
import { LossProvisionProps } from '../../types.LoanDetails'

const LossProvision: FC<LossProvisionProps> = ({ data: { base, reserveauto, reserveman }, ID, hash, manRates }) => (
  <div className="u-fluid u-directionColumn u-flex">
    <div className="u-fluid u-flex">
      <div style={{ flex: 1, position: 'relative' }}>
        <ReserveAuto
          instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-ReserveAuto`}
          data={reserveauto}
          disabled={base.ReserveSystem !== 1}
        />
      </div>

      <div style={{ flex: 2, position: 'relative' }}>
        <ReserveMan
          instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-ReserveMan`}
          data={reserveman}
          disabled={base.ReserveSystem !== 2}
        />
      </div>

      <div style={{ flex: 2, borderBottom: '1px solid lightgray' }}>
        {/*@ts-ignore */}
        <ReserveCalc ID={ID} hash={hash} />
      </div>
    </div>

    {/*@ts-ignore */}
    <Controls manRates={manRates} />
  </div>
)

export default withLookups({
  type: 'loanview',
  query: ['ManResRates as manRates'],
})(LossProvision)
